module.exports = __webpack_public_path__ + "static/media/relevance-settings-guide.8fb862db.png";